/**
 * Class to assist with OAuth flows
 * Initiates an OAuth flow by opening a new window with a given target URL & producing a Promise.
 * When the user agent returns to the callback endpoint, the Promise resolves with the parameters
 * included in the OAuth response
 */
export default class {
  /**
   * Create a new OAuthHandler instance
   * Registers this instance against the given endpoint so that Promises created by this instance
   * correlate correctly with OAuth responses
   * @param {string} cbEndpoint OAuth callback endpoint
   */
  constructor(cbEndpoint) {
    this._identifier = Math.random().toString(36).substring(2);
    this._responseListeners = [];

    const oauthCbRoutes = JSON.parse(sessionStorage.getItem('oauthCbRoutes')) || {};
    oauthCbRoutes[cbEndpoint] = this._identifier;
    sessionStorage.setItem('oauthCbRoutes', JSON.stringify(oauthCbRoutes));
  }

  /**
   * Initiate OAuth login flow by opening new window at specified target
   * Returns Promise that resolves once the opened window has been redirected back
   * to the OAuth callback endpoint
   * @param {string} location OAuth init location to direct user to
   * @return {Promise<string>} Promise that resolves to OAuth callback parameters
   */
  initiate(location) {
    this._responseListeners.forEach((cb) => {
      window.removeEventListener('storage', cb);
    });

    return new Promise((res) => {
      const callback = (store) => {
        if (store.key === this._identifier) {
          localStorage.removeItem(this._identifier);
          res(store.newValue);
        }
      };

      this._responseListeners.push(callback);
      window.addEventListener('storage', callback);

      window.open(
        location,
        '_blank',
        'height=500,width=400,channelmode=yes,location=no,menubar=no,resizable=no,toolbar=no'
      );
    });
  }
}
